module.exports = __webpack_public_path__ + "static/media/Slider1.d46ed2d3.png";